import BaseHttpClient from '../../base'
import { apis, getApiUrl } from '../api-config'

/**
 * Đơn vị công tác
 */
class OrganizationAPI extends BaseHttpClient {}

export default new OrganizationAPI('v1/organizations', 'Organization', getApiUrl(apis.AuthAPI))
